module.exports = __webpack_public_path__ + "img/versapay-overview-5.767727b7.png";